import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const newsSlice = createSlice({
  name: "news",
  initialState: {
    newsData: [],
    isLoading: false,
    isError: false,
  },

  reducers: {
    fetchNewsStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchNewsSuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.newsData = action.payload;
    },
    fetchNewsFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const { fetchNewsStart, fetchNewsSuccess, fetchNewsFailure } =
  newsSlice.actions;

export const fetchNews = () => async (dispatch) => {
  try {
    dispatch(fetchNewsStart());
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchNewsSuccess(response.data.market_news));
  } catch (error) {
    dispatch(fetchNewsFailure());
  }
};

export default newsSlice.reducer;
